import { render, staticRenderFns } from "./addGoods.vue?vue&type=template&id=3129e1af&scoped=true"
import script from "./addGoods.vue?vue&type=script&lang=js"
export * from "./addGoods.vue?vue&type=script&lang=js"
import style0 from "./addGoods.vue?vue&type=style&index=0&id=3129e1af&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3129e1af",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3129e1af')) {
      api.createRecord('3129e1af', component.options)
    } else {
      api.reload('3129e1af', component.options)
    }
    module.hot.accept("./addGoods.vue?vue&type=template&id=3129e1af&scoped=true", function () {
      api.rerender('3129e1af', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/systemAdministrator/brandSelection/components/addGoods.vue"
export default component.exports